// extracted by mini-css-extract-plugin
module.exports = {"image":"_9330de7794--image--HCbCM","image-icon":"_9330de7794--image-icon--WW3ow"};